import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import cx from "classnames";
import skeletonStyles from "../skeleton.module.css";
import styles from "./tags.module.css";
export const Tags = ({ items =[] , isPending =false , listStyleClassName , listItemClassName , isUpperCaseText =true  })=>/*#__PURE__*/ _jsx("ul", {
        className: cx(styles.list, listStyleClassName || "", {
            [skeletonStyles.base]: isPending,
            [skeletonStyles.active]: isPending,
            [styles.upperCase]: isUpperCaseText
        }),
        children: items.map(({ label , value  })=>/*#__PURE__*/ _jsx(Text, {
                element: "li",
                fontSizeFixed: "3xs",
                className: cx(styles.item, listItemClassName || "", {
                    [skeletonStyles.base]: isPending,
                    [skeletonStyles.active]: isPending
                }),
                title: label,
                children: value
            }, label))
    });
export default Tags;
